import { useState } from "react";
import { toast } from "sonner";
import { ShareNetwork, LinkSimple, Check } from "@phosphor-icons/react";

export default function ShareButton({ cacheKey, verdict }) {
  const [copied, setCopied] = useState(false);
  if (!cacheKey) return null;

  const shareUrl = `${window.location.origin}/check/${cacheKey}`;
  const shareText = verdict
    ? `Verdict: ${verdict} — verified on TrueStream`
    : "Fact-checked on TrueStream";

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      toast.success("Link copied to clipboard");
      setTimeout(() => setCopied(false), 2500);
    } catch {
      toast.error("Could not copy — please copy manually");
    }
  };

  const nativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: "TrueStream Verdict", text: shareText, url: shareUrl });
      } catch {
        // user cancelled
      }
    } else {
      copy();
    }
  };

  return (
    <div className="flex items-center gap-2" data-testid="share-panel">
      <button
        onClick={copy}
        data-testid="copy-share-link-button"
        className="flex items-center gap-1.5 border-2 border-black bg-white px-3 py-1.5 font-mono-plex text-[10px] font-semibold hover:bg-zinc-900 hover:text-white transition-colors"
        title="Copy shareable link"
      >
        {copied ? (
          <Check weight="bold" className="w-3.5 h-3.5" />
        ) : (
          <LinkSimple weight="bold" className="w-3.5 h-3.5" />
        )}
        {copied ? "COPIED" : "COPY LINK"}
      </button>
      <button
        onClick={nativeShare}
        data-testid="native-share-button"
        className="flex items-center gap-1.5 bg-black text-white px-3 py-1.5 font-mono-plex text-[10px] font-semibold hover:bg-zinc-800 transition-colors"
        title="Share"
      >
        <ShareNetwork weight="fill" className="w-3.5 h-3.5" />
        SHARE
      </button>
    </div>
  );
}
